import React, {Component} from "react";
import config from 'react-global-configuration';
import axios from "axios";
import Select from 'react-select';
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import { reactSelectStyles } from '../helpers/utils.js';

class TenureFilter extends Component {
    state = {
         tenureLists:[],
         tenureValue:'',
    };
    componentDidMount(){
        this._getTenure(this.props.start_date,this.props.end_date);
    }

    resetTenureFilter(){
        this.setState({
        tenureValue: [],
        })
    }

     _getTenure(start_date,end_date){
        axios.post(config.get('API_URL')+'/reports/get-sales-emi-tenure/',{
                yestSend: start_date,
                todSend: end_date,
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            }).then(response => {
            if(Array.isArray(response.data) && response.data.length) {
                response.data.map((Tenure, index) => {
                    this.state.tenureLists.push({value: Tenure.tenure, label: Tenure.tenure})
                });
            }
        });
    }
    changeTenure(optionSelected){
        let value='';
        let tenureArray = [];
        if(optionSelected===null){
            value = null;
        }
        else{
            optionSelected.map((mids, i) => {
                tenureArray.push(mids.value)
//                 var index = this.state.tenureLists.findIndex(obj => obj.value==mids.value);
//                 this.state.tenureLists.move(index,0).join(',');
            });
        }
        this.props.onSelectTenure(optionSelected, tenureArray);
        this.setState({
            tenureIDs:tenureArray,
            tenureValue:optionSelected,
        });
        // this.get_filtered_emi_sales_report(this.state.merchantID, this.state.chainID, this.state.storeID, this.state.acqBankIds, this.state.cityIds,
        //     this.state.yestSend, this.state.todSend, this.state.metric, this.state.categoryIDs, this.state.brandIDs, this.state.modelIDs, tenureArray, this.state.subventionIDs, this.state.emiIssuerIDs, this.state.emiSchemeIDs);
    }

    render() {

        return (
            <ReactMultiSelectCheckboxes name="tenure"
            isMulti
            value={this.state.tenureValue}
            styles={reactSelectStyles} className="report-listbox"
            isClearable={false}
            onChange={this.changeTenure.bind(this)}
            options={this.state.tenureLists}
            placeholderButtonLabel="Select [Tenure]"
        />
        );

    }
}
export default TenureFilter;